module.exports = __webpack_public_path__ + "img/pro_0.9e1ed190.png";